/* eslint-disable-next-line @github-ui/github-monorepo/no-use-app-payload -- isolated dotcom-only seed adapter; this Relay navigator app isn't on the data router and Alloy SSR has no request context, so the cookie value must arrive via the dotcom payload here. */
import {useAppPayload} from '@github-ui/react-core/use-app-payload'

type SidebarSeedPayload = {
  sidebar_expanded?: boolean
}

/**
 * Reads the dotcom app-payload sidebar seed (`sidebar_expanded`, set by Rails
 * from the `primer_sidebar_expanded` cookie). On dotcom the sidebar is a Relay
 * navigator app rendered by Alloy with no request context, so the payload is
 * the only way the cookie reaches React — keep this the single reader.
 *
 * Transitional: the app payload is deprecated in favor of layout route data
 * (data-router pages read the seed from `IssuesLayoutPayload`). Remove once the
 * navigator pages migrate to the data router.
 */
export function useInitialSidebarExpanded(): boolean | undefined {
  return useAppPayload<SidebarSeedPayload>()?.sidebar_expanded
}
